import { memo, FC } from "react";

export const Page404: FC = memo(() => {
    return <p>ページが見つかりません</p>
});

export{}